import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChatAvatarComponent } from './chat-avatar/chat-avatar.component';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import { ChatInputComponent } from './chat-input/chat-input.component';
import { ChatConfigComponent } from './chat-config/chat-config.component';
import { ChatService } from './chatbot-rasa.service';
import { KeysPipe } from '@app/@core/pipes/array-keys.pipe';
@NgModule({
  imports: [CommonModule, BrowserAnimationsModule],
  declarations: [ChatAvatarComponent, ChatWidgetComponent, ChatInputComponent, ChatConfigComponent, KeysPipe],
  exports: [ChatWidgetComponent, ChatConfigComponent],
  // entryComponents: [ChatWidgetComponent, ChatConfigComponent, HighchartsChartComponent],
  providers: [ChatService],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ChatbotRasaModule {}
